/*
 paymentmethods
 parse data from rest-api into app-specific format
 */
// "paymentMethods": [{
//     "sendHandlerType": "SEND_HANDLER_CONTROLLER",
//     "logoImgClasses": ["visa",
//         "mastercard",
//         "visa_electron",
//         "maestro",
//         "default"
//     ],
//     "methodText": "Credit Card",
//     "methodId": 1,
//     "methodName": "Credit Card",
//     "executeUrl": "/CreditCardIntegration/executeDeposit",
//     "methodInfo": "Type in your card details or select a previously saved card, choose your bonus, select the amount and make a deposit.",
//     "formTemplateCode": "CREDIT-CARD",
//     "formTemplateUrlParams": "\u0026paymentMethodId\u003d1\u0026paymentType\u003ddeposit",
//     "paymentType": "deposit"
// },...
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import dataflow from '../../common/lib/dataflow.js';
import view from './view.js';

const register = dataflow.register;

const state = {
	formTemplateCode: {},
	lastUsedMethodDetails: null,
	playerCurrency: null,
	methods: {
		by_id: {},
		by_name: {}
	},
	selected: {
		id: 1,
		text: 'default' // this reflects the name of the method, and may be changed according to textkeys. 'default' method is selected by the id: 1;
	},
	selectedId: null
};

function viewUpdate() {
	view.update({
		paymentmethods: state
	});
}

function lastUsedName(id, methodsById) {
	const name = ((id && methodsById) ? (methodsById[id] && methodsById[id].methodName) : null);
	return name;
}

function sortByName(arr) {
	let obj = null;
	let key = null;
	if (arr && arr.length > 0) {
		obj = {};
		arr.forEach((elm) => {
			key = elm.methodName;
			obj[key] = elm;
		});
	}
	return obj;
}

function sortById(arr) {
	let obj = null;
	let key = null;
	if (arr && arr.length > 0) {
		obj = {};
		arr.forEach((elm) => {
			key = elm.methodId;
			obj[key] = elm;
		});
	}
	return obj;
}

function sortByFormTemplateCode(arr) {
	/*
	Sort on method-template-type.
	templatecode is the type of the method, for example
	CREDIT-CARD, EMAIL-CURRENCIES, CLICK-TO-PAY, TWO-FIELDS, NETELLER, BANKWIRE
	A selected method has one of these types.
	*/
	const obj = {};
	if (arr && arr.length > 0) {
		arr.forEach((elm) => {
			const key = elm.formTemplateCode;
			obj[key] = elm.formTemplateMobileUrl;
		});
	}
	return obj;
}

function registerActions() {
	function paymentmethods(payload) {
		if (payload.type === constants.FETCH_PAYMENTMETHODS) {
			/* the non-modified response from the ajax-call*/
			const payloadDataPaymentMethods = (payload.data && payload.data.paymentMethods);
			const payloadDataFormTemplateTypes = (payload.data && payload.data.formTemplateTypes);
			const templateTypesByCode = sortByFormTemplateCode(payloadDataFormTemplateTypes);
			const methodsByName = sortByName(payloadDataPaymentMethods);
			const methodsById = sortById(payloadDataPaymentMethods);
			// const payloadDataFormTemplateCode
			const validData = (payloadDataPaymentMethods.length && payloadDataPaymentMethods.length > 0);
			const payloadDataPlayerCurrency = (payload.data && payload.data.playerCurrency);
			const lastUsedMethodDetails = (payload.data && payload.data.lastUsedMethodDetails);
			const lastAmount = (lastUsedMethodDetails && lastUsedMethodDetails.lastAmount);
			const lastCurrency = (lastUsedMethodDetails && lastUsedMethodDetails.lastCurrency);
			const lastUsedMethodId = (lastUsedMethodDetails && lastUsedMethodDetails.lastPaymentMethodId);
			const lastUsedMethod = ((lastUsedMethodId && methodsById) && methodsById[lastUsedMethodId]);
			const lastUsedTypeCode = (lastUsedMethod && lastUsedMethod.formTemplateCode);
			const lastUsedDetailsUrl = ((templateTypesByCode && lastUsedTypeCode) && templateTypesByCode[lastUsedTypeCode]);
			const lastUsedDetailsParams = (lastUsedMethod && lastUsedMethod.formTemplateUrlParams);
			// const lastUsedDetailsUrl = ();
			const lastUsedMethodName = lastUsedName(lastUsedMethodId, methodsById);
			// const lastUsedMethodDetailsUrl =
			const firstDeposit = Boolean(lastUsedMethodDetails && lastUsedMethodDetails.firstDeposit);
			if (validData) {
				state.methods.by_id = methodsById;
				state.methods.by_name = methodsByName;
				state.formTemplateCode = templateTypesByCode;
				state.playerCurrency = payloadDataPlayerCurrency;
				state.lastUsedMethodDetails = lastUsedMethodDetails;
				state.lastAmount = lastAmount;
				state.lastCurrency = lastCurrency;
				state.lastUsedMethodId = lastUsedMethodId;
				state.selectedId = lastUsedMethodId;
				state.lastUsedMethodEqualsNew = true; /* reset */
				state.selected.id = lastUsedMethodId;
				state.selectedId = lastUsedMethodId; // To simplify the reading of this state, the id is stored at a less deep level
				state.selectedText = lastUsedMethodName;
				state.selected.text = lastUsedMethodName;
				state.selectedMethodName = lastUsedMethodName;
				state.selectedDetailsUrl = lastUsedDetailsUrl;
				state.selectedDetailsParams = lastUsedDetailsParams;
				// state.selectedTemplateUrl = lastUsedTypeCode;
				state.firstDeposit = firstDeposit;
				viewUpdate();
				actions.paymentmethods(state);
			} else {
				console.error('paymentmethods:128:FETCH_PAYMENTMETHODS: response has no methods', payload);
				state.error = true;
			}
			viewUpdate();
		}
		if (payload.type === constants.VIEW_METHODS) {
			/* publish details about the new selected method, update view*/
			const selectedId = payload.id;
			const selectedName = payload.text;
			state.selected.id = selectedId;
			state.selectedId = selectedId; // To simplify the reading of this state, the id is stored at a less deep level
			state.selectedText = selectedName;
			state.selected.text = selectedName;

			const paymentMethodSelected = state.methods.by_id[selectedId];
			state.selectedDetailsParams = paymentMethodSelected.formTemplateUrlParams;
			const formTemplateCodeSelectedMethod = paymentMethodSelected.formTemplateCode;
			state.selectedDetailsUrl = state.formTemplateCode[formTemplateCodeSelectedMethod];
			state.selectedMethodName = paymentMethodSelected.methodName;


			state.lastUsedMethodEqualsNew = (state.lastUsedMethodId === selectedId);
			state.methodswitch = true;
			viewUpdate();
			actions.paymentmethods(state);
			state.methodswitch = false;
		}
		// if (payload.type === constants.VIEW_AMOUNTINPUT && payload.data) {
			// a new amount is manually added in the amountinput field
			// this value should be prioritized over 'last used for an account'
			// when selecting a new method.
			// key 'amountmanuallyset' is preferrably changed or maybe the
			// state.lastAmount is used.
			// state.amountmanuallyset = payload.data.amount;
			// the next time fees and limits is fetched this amount can be used.
		// }
	}
	register(paymentmethods);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/paymentmethods.js